// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoSt2 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.st_2";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoSt2 {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Acceptar cookies i accedir de forma gratuïta",
                "cs": "Přijmout cookies a získat přístup zdarma",
                "da": "Accepter cookies og få gratis adgang",
                "de": "Cookies akzeptieren und kostenlosen Zugriff erhalten",
                "el": "Αποδοχή cookies και δωρεάν πρόσβαση",
                "en": "Accept cookies and access for free",
                "es": "Aceptar cookies y acceder de forma gratuita",
                "eu": "Cookieak onartu eta doan sartzeko",
                "fi": "Hyväksy evästeet ja käytä ilmaiseksi",
                "fr": "Accepter les cookies et accéder gratuitement",
                "gl": "Aceptar cookies e acceder de balde",
                "hi": "कुकी स्वीकार करें और मुफ्त पहुंच प्राप्त करें",
                "hu": "Sütik elfogadása és ingyenes hozzáférés",
                "it": "Accetta i cookie e accedi gratuitamente",
                "nl": "Cookies accepteren en gratis toegang krijgen",
                "no": "Godta informasjonskapsler og få gratis tilgang",
                "pl": "Zaakceptuj pliki cookie i uzyskaj dostęp za darmo",
                "pt": "Aceitar cookies e aceder gratuitamente",
                "ro": "Acceptați cookie-urile și accesați gratuit",
                "ru": "Принять файлы cookie и получить бесплатный доступ",
                "sv": "Acceptera cookies och få gratis tillgång",
                "tr": "Çerezleri kabul edin ve ücretsiz erişim sağlayın"
            },
            "defecto": "Accept cookies and access for free"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
